import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/page/main'
import Price from '@/page/price'
import ProblemCommon from '@/page/problem/problem-common'
import Problem from '@/page/problem/problem'
import ProblemDesc from '@/page/problem/problem-desc'
import ProblemResult from '@/page/problem/problem-result'
import WaybillCommon from '@/page/waybill/waybill-common'
import WaybillQuery from '@/page/waybill/waybill-query'
import Waybill from '@/page/waybill/waybill'
import WaybillDesc from '@/page/waybill/waybill-desc'
import OrderCommon from '@/page/order/order-common'
import OrderQuery from '@/page/order/order-query'
import Order from '@/page/order/order'
import OrderDesc from '@/page/order/order-desc'
import Transfer from '@/page/transfer'
import Bill from '@/page/bill'
import Balance from '@/page/balance'
import Remote from '@/page/remote'
import Login from '@/page/mbLogin'
import MsgDetail from '@/page/msgDetail'


Vue.use(Router);
export default new Router({
    routes: [
        {
            path: '/',
            name: 'Main',
            component: Main
        }, {
            path: '/price',
            name: 'Price',
            component: Price
        }, {
            path: '/problemCommon',
            name: 'problemCommon',
            component: ProblemCommon,
            children: [
                {
                    path: 'problem',
                    name: 'Problem',
                    component: Problem
                }, {
                    path: 'problem-desc',
                    name: 'ProblemDesc',
                    component: ProblemDesc
                }, {
                    path: 'problem-result',
                    name: 'ProblemResult',
                    component: ProblemResult
                },
            ]
        }, {
            path: '/waybillCommon',
            name: 'waybillCommon',
            component: WaybillCommon,
            children: [
                {
                    path: 'waybill-query',
                    name: 'WaybillQuery',
                    component: WaybillQuery
                },
                {
                    path: 'waybill',
                    name: 'Waybill',
                    component: Waybill
                }, {
                    path: 'waybill-desc',
                    name: 'WaybillDesc',
                    component: WaybillDesc
                }
            ]
        }, {
            path: '/orderCommon',
            name: 'orderCommon',
            component: OrderCommon,
            children: [
                {
                    path: 'order-query',
                    name: 'OrderQuery',
                    component: OrderQuery
                },
                {
                    path: 'orderList',
                    name: 'Order',
                    component: Order
                }, {
                    path: 'order-desc',
                    name: 'OrderDesc',
                    component: OrderDesc
                }
            ]
        }, {
            path: '/transfer',
            name: 'Transfer',
            component: Transfer
        }, {
            path: '/bill',
            name: 'Bill',
            component: Bill
        }, {
            path: '/balance',
            name: 'Balance',
            component: Balance
        }, {
            path: '/remote',
            name: 'Remote',
            component: Remote
        }, {
            path: '/login',
            name: 'Login',
            component: Login
        }, {
            path: '/msgDetail',
            name: 'MsgDetail',
            component: MsgDetail
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js